import { UPDATE_NOTES } from "../_constants/actionConstants";

const updateNotesInitialState = {
  latest: "",
  list: [],
  fetching: false,
};

export const reducer = (state = updateNotesInitialState, action) => {
  switch (action.type) {
    case UPDATE_NOTES.FETCH:
    case UPDATE_NOTES.FETCH_ALL:
      return { ...state, fetching: true };

    case UPDATE_NOTES.FETCH_FULFILLED: {
      const { latestUpdateNotes } = action;
      return { ...state, latest: latestUpdateNotes, fetching: false };
    }

    default:
      return { ...state };
  }
};
